// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function NewPlusPlusSlide() {
  return (
    <div className="slide-content feature-slide">
      <div className="feature-demo">
        <iframe width="100%"
            src="https://www.youtube.com/embed/C-1Q3VAMC3g?autoplay=1&mute=0&loop=1&playlist=C-1Q3VAMC3g"
            title="New++ demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen></iframe>
      </div>

      <div className="feature-header">
        <div className="feature-category">New++</div>
        <h2 className="slide-title">Create templates quickly from the context menu</h2>
        <p className="slide-text">
          Use New++ to create files and folders from your personalized templates directly
          in the Windows context menu — speed up repetitive file creation with a click.
        </p>
      </div>
    </div>
  )
}

export default NewPlusPlusSlide
